<template>
  <div class="flex items-center gap-2">
    <span class="text-sm text-muted-foreground whitespace-nowrap hidden sm:inline">{{ $t('Sort by') }}:</span>
    <SelectNative
      v-model="selectedSort"
      @change="handleChange"
      data-testid="sort-filter"
    >
      <option
        v-for="option in normalizedOptions"
        :key="option.value"
        :value="option.value"
        :disabled="option.disabled"
      >
        {{ $t(option.label) }}
      </option>
    </SelectNative>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import type { PropType } from 'vue';
import { SelectNative } from './ui/select-native';

interface SortOption {
  value: string;
  label: string;
  disabled?: boolean;
}

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  options: {
    type: Array as PropType<SortOption[]>,
    default: () => [
      { value: '', label: 'sort.relevance' },
      { value: 'title:asc', label: 'sort.title_asc' },
      { value: 'title:desc', label: 'sort.title_desc' },
      { value: 'date_add:desc', label: 'sort.date_add_desc' },
      { value: 'popularity:desc', label: 'sort.popularity' },
      { value: 'price:desc', label: 'sort.price_desc' },
      { value: 'price:asc', label: 'sort.price_asc' },
      { value: 'discount_percentage:desc', label: 'sort.discount_desc' },
      { value: 'discount_percentage:asc', label: 'sort.discount_asc' },
    ],
  },
  class: {
    type: [String, Object, Array],
    default: 'text-sm',
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
  (e: 'change', value: string): void;
}>();

const selectedSort = ref(props.modelValue);

// Ensure first option is always the default empty option
const normalizedOptions = computed(() => {
  const options = [...props.options];
  if (options[0]?.value !== '') {
    options.unshift({ value: '', label: 'sort.relevance', disabled: true });
  }
  return options;
});

watch(
  () => props.modelValue,
  (newVal) => {
    selectedSort.value = newVal;
  },
);

function handleChange() {
  emit('update:modelValue', selectedSort.value);
  emit('change', selectedSort.value);
}
</script>
